<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <AwsSku
          :disabled="disabled"
          :isSpuCopy="isSpuCopy"
          :amzSpuCode="amzSpuCode"
          :amzSkuCode="amzSkuCode"
          :form="form"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import AwsSku from '@/views/ecom/base/awsGoods/components/aws-sku'
export default {
  components: { AwsSku },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isSpuCopy: { type: Boolean, default: false },
    amzSpuCode: { type: String, default: '' },
    amzSkuCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
  },
  methods: {
    close() {
      if (!this.disabled) this.$emit('close')
      this.$emit('update:visible', false)
    },

    handleClose(done) {
      if (this.disabled) {
        done()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 10px 12px;
}

::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
